<template>
    <div class="d-flex w-100 mt-4">
        <div class="col-sm-12 col-md-4 offset-md-4">
            <div class="card shadow">
                <div class="card-body p-5">

                    <h2 v-if="appId && model.app.name">{{model.app.name}} Sign Up</h2>
                    <h2 v-else>Sign Up</h2>

                    <div v-if="errorMessage" class="alert alert-warning" role="alert">
                        {{errorMessage}}
                    </div>

                    <form class="my-1">

                        <div class="mb-3">
                            <label for="user_name">Name</label><br>
                            <input v-model="user.name" autofocus="autofocus" autocomplete="off" class="form-control"
                                   type="text" id="user_name">
                        </div>

                        <div class="mb-3">
                            <label for="user_email">Email</label><br>
                            <input v-model="user.email" autofocus="autofocus" autocomplete="off" class="form-control"
                                   type="email" id="user_email">
                        </div>

                        <div class="mb-3">
                            <label for="user_password">Password</label><br>
                            <input v-model="user.password" autocomplete="off" class="form-control" type="password"
                                   id="user_password">
                        </div>

                        <div class="mb-3">
                            <label for="user_password_confirmation">Password confirmation</label><br>
                            <input v-model="user.password_confirmation" autocomplete="off" class="form-control"
                                   type="password"
                                   id="user_password_confirmation">
                        </div>

                        <div class="actions">
                            <button class="btn btn-primary btn-rounded btn-wide" @click.prevent="onSignupClick">Sign
                                up
                            </button>
                        </div>
                    </form>

                    <div class="mt-4">
                        <router-link :to="{ name: 'sign-in'}">
                            Already have an account? Log in.
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "./services/UserService";

    export default {
        name: 'SignUp',
        data() {
            return {
                model: webase.model,
                user: {
                    name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    invite_uuid: null,
                    app_id: null
                },
                errorMessage: null,
                appId: null
            }
        },
        mounted() {

            if (this.$route.params.app_id) {
                this.appId = this.$route.params.app_id
                console.log('App ID: ' + this.appId)
            }

            if (this.$route.query.uuid) {
                this.user.invite_uuid = this.$route.query.uuid
            }
        },
        methods: {
            onSignupClick() {
                if (this.appId) {
                    this.user.app_id = this.model.app.index // need integer ID
                }

                let service = new UserService()
                let site = window.location.hostname
                service.signUp(this.user, site).then((response) => {
                    WEBASE_SYSTEM_ID = response.auth_token
                    webase.model.auth_token = WEBASE_SYSTEM_ID
                    webase.model.user_id = response.id
                    window.localStorage.setItem('WEBASE_SYSTEM_ID', webase.model.auth_token)

                    if (this.appId) {
                        this.$router.push({name: 'public-app', params: {id: this.appId} })
                    } else {
                        this.$router.push({name: 'apps'})
                    }

                }).catch((error) => {
                    this.errorMessage = webase.utils.notification.parseErrorData(error.errors)
                })
            }
        }
    }
</script>

<style>

</style>
